// extracted by mini-css-extract-plugin
export default {"hidden":"Collapsible_hidden__CHHUL","collapsibleHeaderContainer":"Collapsible_collapsibleHeaderContainer__jeNG+"};